const DESCRIPTOR_KEYS = ["stagingCompiledDescriptor", "productionCompiledDescriptor"];

function hasCompiledDescriptor(blclientData) {
  return DESCRIPTOR_KEYS.some(key => Boolean(blclientData?.[key]));
}

function resolvesScopedProvides({ renderingInProduction = false, blclientData = null } = {}) {
  return Boolean(renderingInProduction) || hasCompiledDescriptor(blclientData);
}

module.exports = { resolvesScopedProvides, hasCompiledDescriptor };
